import { RequestPayload } from '../../../../../shared/adapters/request-payload';

/** Request com os dados para imprimir um orçamento */
export class PedidoOrcamentoPrintRequestPayload extends RequestPayload {
    id: number;

    constructor(id: number) {
        super();
        this.id = id;
    }

    /** Verifica se os dados para imprimir o orçamento estão válidos */
    isValid(): boolean {
        // Sem orçamento
        if (!this.id) {
            this.setPropError('id');
            this.setMessageError('O orçamento para imprimir não foi informado. Infome o orçamento para poder imprimir');
            return false;
        }

        return true;
    }
}
